import { useEffect, useState } from "react";
import { Numeral } from "react-numeral";

import {
  AdvancePayment,
  Annexes,
  Authorizations,
  Collection,
  Constitution,
  Contact,
  CurrentInterest,
  Damages,
  Debit,
  DefaultInterest,
  Disbursement,
  Expiration,
  Extend,
  Founds,
  Indebtedness,
  Intro,
  KYC,
  MethodPayment,
  Notification,
  PersonalData,
  Place,
  Product,
  ProductContracted,
  Report,
  Requirements,
  Responsabilities,
  Retract,
  Rights,
  SignE,
  SignM,
  Tx,
  Verify,
} from "../ContentContractV2";
import { FirmaE } from "../Firma";
import { companyDatas, getUserData } from "../Content";


export function ContractV2({
  basicInfo,
  userinfo,
  creditUser,
  firmaElectronica,
  dctoFirmaElectronica,
  total
}) {
  const [userData, setUserData] = useState([]);

  const handleUserData = () => {
    let userData = getUserData(basicInfo, userinfo);
    setUserData(userData);
  };

  useEffect(() => {
    handleUserData();
  }, [creditUser, basicInfo, userinfo])


  return (
    <>
      <div className="text-sm py-8 px-4">
        <div className="uppercase text-center w-full font-bold">
          <div className="w-full">
            <div>
              CONTRATO DE CRÉDITO GRUPO EMPRESARIAL ANAV S.A.S. –{" "}
              <span className="normal-case">(en adelante “Galilea”)</span>
            </div>
          </div>
        </div>
        <div className="pt-4">
          <span className="uppercase font-bold">Acreedor:</span>
        </div>
        {companyDatas.map((companyData, index) => (
          <ul key={index} role="list" className="marker:text-purple list-disc">
            <div key={index} className="pl-4 grid grid-cols-5">
              <div className="col-span-2">
                <li>{companyData.title}</li>
              </div>
              <div className="col-span-3 ml-2">
                <span>{companyData.value}</span>
              </div>
            </div>
          </ul>
        ))}
        <div className="pt-4">
          <span className="uppercase font-bold">Deudor:</span>
        </div>
        {userData.map((userData, index) => (
          <ul key={index} role="list" className="marker:text-purple list-disc">
            <div key={index} className="pl-6 grid grid-cols-5">
              <div className="col-span-2">
                <li>{userData.title}</li>
              </div>
              <div className="col-span-3 ml-2">
                <Numeral format={"0,0"} value={userData.number} />
                <span>{userData.value}</span>
              </div>
            </div>
          </ul>
        ))}
        <Intro />
        <div className="pt-4">
          <span className="uppercase font-bold">1. Producto</span>
        </div>
        <Product />
        <div className="pt-4">
          <span className="uppercase font-bold">
            1.1. Producto contratado en el presente contrato.{" "}
          </span>
        </div>
        <ProductContracted
          creditUser={creditUser}
          firmaElectronica={firmaElectronica}
          dctoFirmaElectronica={dctoFirmaElectronica} 
          total={total}
          />
        <div className="pt-4">
          <span className="uppercase font-bold">1.2. Requisitos. </span>
        </div>
        <Requirements />
        <div className="pt-4">
          <span className="uppercase font-bold">
            2. Responsabilidad del Deudor de suscribir los documentos del
            Crédito.
          </span>
        </div>
        <Responsabilities />
        <div className="pt-4">
          <span className="uppercase font-bold">
            2.1. Firma Electrónica de los documentos del crédito.
          </span>
        </div>
        <SignE />
        <div className="pt-4">
          <span className="uppercase font-bold">
            2.2. Firma manuscrita- Proceso de firma física.
          </span>
        </div>
        <SignM />
        <div className="pt-4">
          <span className="uppercase font-bold">3. Desembolso.</span>
        </div>
        <Disbursement />
        <div className="pt-4">
          <span className="uppercase font-bold">
            4. Autorizaciones y declaraciones para el producto de crédito.
          </span>
        </div>
        <Authorizations />
        <div className="pt-4">
          <span className="uppercase font-bold">
            5. Constitución de garantía para el pago de las obligaciones.
          </span>
        </div>
        <Constitution />
        <div className="pt-4">
          <span className="uppercase font-bold">6. Intereses:</span>
        </div>
        <div className="pt-4">
          <span className="uppercase font-bold">
            6.1. Remuneratorio o corriente.{" "}
          </span>
        </div>
        <CurrentInterest />
        <div className="pt-4">
          <span className="uppercase font-bold">
            6.2. Moratorios o resarcitorios.
          </span>
        </div>
        <DefaultInterest />
        <div className="pt-4">
          <span className="uppercase font-bold">
            7. Vencimiento de la obligación adquirida por parte del Usuario.
          </span>
        </div>
        <Expiration />
        <div className="pt-4">
          <span className="uppercase font-bold">
            8. Notificación y aceptación de cesión:
          </span>
        </div>
        <Notification />
        <div className="pt-4">
          <span className="uppercase font-bold">9. Medio de pago.</span>
        </div>
        <MethodPayment />
        <div className="pt-4">
          <span className="uppercase font-bold">
            10. Derecho al pago anticipado de mi obligación.{" "}
          </span>
        </div>
        <AdvancePayment />
        <div className="pt-4">
          <span className="uppercase font-bold">11. Derecho al Retracto.</span>
        </div>
        <Retract />
        <div className="pt-4">
          <span className="uppercase font-bold">
            12. Autorizaciones para el Débito Automático.
          </span>
        </div>
        <Debit basicInfo={basicInfo} />
        <div className="pt-4">
          <span className="uppercase font-bold">
            13. Gestión de Cobranza Pre-jurídica o Jurídica.
          </span>
        </div>
        <Collection />
        <div className="pt-4">
          <span className="uppercase font-bold">
            14. Autorización para realizar reportes de tus créditos ante las
            Centrales de Información.
          </span>
        </div>
        <Report userInfo={userinfo} />
        <div className="pt-4">
          <span className="uppercase font-bold">
            15. Posibilidad de novar tu obligación con Galilea.
          </span>
        </div>
        <Extend />
        <div className="pt-4">
          <span className="uppercase font-bold">
            16. Protección al Usuario de no incurrir en sobreendeudamiento.
          </span>
        </div>
        <Indebtedness />
        <div className="pt-4">
          <span className="uppercase font-bold">
            17. Declaración de origen y utilización de fondos utilizados para
            los productos ofrecidos por Galilea.
          </span>
        </div>
        <Founds />
        <div className="pt-4">
          <span className="uppercase font-bold">
            18. Autorizaciones generales para el tratamiento de datos
            personales.
          </span>
        </div>
        <PersonalData />
        <div className="pt-4">
          <span className="uppercase font-bold">19. Derechos del Usuario.</span>
        </div>
        <Rights />
        <div className="pt-4">
          <span className="uppercase font-bold">
            20. Lugar de celebración del presente contrato y legislación
            aplicable.{" "}
          </span>
        </div>
        <Place />
        <div className="pt-4">
          <span className="uppercase font-bold">
            21. Validación de identificación personal.{" "}
          </span>
        </div>
        <KYC />
        <div className="pt-4">
          <span className="uppercase font-bold">
            22. Veracidad de la información suministrada.
          </span>
        </div>
        <Verify />
        <div className="pt-4">
          <span className="uppercase font-bold">23. Perjuicios.</span>
        </div>
        <Damages />
        <div className="pt-4">
          <span className="uppercase font-bold">
            24. Transacciones adicionales.
          </span>
        </div>
        <Tx />
        <div className="pt-4">
          <span className="uppercase font-bold">
            25. Medios de contacto SAC, cobranza y PQRS.
          </span>
        </div>
        <Contact />
        <div className="pt-4">
          <span className="uppercase font-bold">
            26. Anexos que hacen parte del presente contrato.
          </span>
        </div>
        <Annexes />
        <FirmaE />
      </div>
    </>
  );
}
